import { PureComponent } from 'react';
import clsx from 'clsx';

import * as Service from 'types/service';

interface Props {
  classNames?: string;
  stateDescription: Service.StateDescription;
}

export default class StatusIcon extends PureComponent<Props> {
  render() {
    const { classNames: classNamesFromProps, stateDescription } = this.props;

    const classNames = clsx('StatusIcon', classNamesFromProps);
    const dotClassNames = clsx('StatusIcon-dot', stateDescription.className);

    return (
      <div className={classNames}>
        <div className={dotClassNames} />
      </div>
    );
  }
}
